import { createStore } from "vuex";

const store= createStore({
    state()
    {
        return {
            items:[{
                id:1,
                title:'c++',
                price:100
            }]
        }
    }
})

export default store